import * as React from 'react';
import DraftPlayerStatLine from './DraftPlayerStatLine';
import DraftColumn from './DraftColumn';
import PlayerSearchModal from './PlayerSearchModal';
import styled from 'styled-components';
import { NHLAPI } from '../modules/NHLAPI';
import axios from 'axios';
class DraftChoices extends React.Component {
    constructor() {
        super(...arguments);
        this.newPlayersHash = () => {
            return {
                C: { order: [], info: {} },
                LW: { order: [], info: {} },
                RW: { order: [], info: {} },
                D: { order: [], info: {} },
                G: { order: [], info: {} }
            };
        };
        this.state = {
            players: this.newPlayersHash(),
            showPlayerSearchModal: false,
            playerPosition: 'C',
            selectedPlayer: undefined
        };
        this.nhl = new NHLAPI();
        this.fetchList = () => {
            if (this.props.appState.listId) {
                axios.get('https://draft-assist.firebaseio.com/lists/' + this.props.appState.listId + '/players.json')
                    .then((response) => {
                    this.setState(() => {
                        return {
                            players: Object.assign({}, this.newPlayersHash(), response.data)
                        };
                    });
                })
                    .catch(() => {
                });
            }
        };
        this.save = (players) => {
            axios.put('https://draft-assist.firebaseio.com/lists/' + this.props.appState.listId + '/players.json', players)
                .then(() => {
            })
                .catch(() => {
            });
        };
        this.showPlayerModalHandler = (playerPosition) => {
            this.setState({
                showPlayerSearchModal: true,
                playerPosition: playerPosition
            });
        };
        this.closePlayerModalHandler = () => {
            this.setState({ showPlayerSearchModal: false });
        };
        this.cancelPlayerModalHandler = () => {
            this.setState({ showPlayerSearchModal: false });
        };
        this.selectPlayerHandler = (player) => {
            this.setState({ selectedPlayer: Object.assign({}, player) });
        };
        this.addPlayerHandler = (players) => {
            this.setState((prevState) => {
                const addedPlayers = {
                    order: [],
                    info: {}
                };
                players.forEach((player) => {
                    if (!prevState.players[prevState.playerPosition].info[player.id]) {
                        addedPlayers.order.push(player.id);
                        addedPlayers.info[player.id] = Object.assign({}, player);
                    }
                });
                const _state = {
                    players: Object.assign({}, prevState.players, { [this.state.playerPosition]: Object.assign({}, prevState.players[this.state.playerPosition], { order: [...prevState.players[this.state.playerPosition].order, ...addedPlayers.order], info: Object.assign({}, prevState.players[this.state.playerPosition].info, addedPlayers.info) }) }),
                    showPlayerSearchModal: false
                };
                this.save(_state.players);
                return _state;
            });
        };
        this.removePlayerHandler = (player, playerColumnPosition) => {
            this.setState((prevState) => {
                const order = prevState.players[playerColumnPosition].order;
                order.splice(order.indexOf(player.id), 1);
                const info = prevState.players[playerColumnPosition].info;
                delete info[player.id];
                const _state = {
                    players: Object.assign({}, prevState.players, { [playerColumnPosition]: Object.assign({}, prevState.players[playerColumnPosition], { order: [...order], info: Object.assign({}, info) }) })
                };
                this.save(_state.players);
                return _state;
            });
        };
        this.updatePlayerOrderHandler = (playerPosition, oldIndex, newIndex) => {
            this.setState((prevState) => {
                let order = [...prevState.players[playerPosition].order];
                order.splice(newIndex, 0, order.splice(oldIndex, 1)[0]);
                const _state = {
                    players: Object.assign({}, prevState.players, { [playerPosition]: Object.assign({}, prevState.players[playerPosition], { order: [...order] }) })
                };
                this.save(_state.players);
                return _state;
            });
        };
        this.handlers = {
            showPlayerModal: this.showPlayerModalHandler,
            closePlayerModal: this.closePlayerModalHandler,
            cancelPlayerModal: this.cancelPlayerModalHandler,
            addPlayer: this.addPlayerHandler,
            removePlayer: this.removePlayerHandler,
            updatePlayerOrder: this.updatePlayerOrderHandler,
            selectPlayer: this.selectPlayerHandler
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.appState.listId !== this.props.appState.listId) {
            this.fetchList();
        }
    }
    componentDidMount() {
        this.fetchList();
    }
    render() {
        let playerSearchModal = null;
        if (this.state.showPlayerSearchModal) {
            playerSearchModal = React.createElement(PlayerSearchModal, { show: this.state.showPlayerSearchModal, playerPosition: this.state.playerPosition, handlers: this.handlers });
        }
        return (React.createElement(DraftChoiceStyle, { imageURL: this.state.selectedPlayer ? this.nhl.playerActionShotImage(this.state.selectedPlayer.id) : "none" },
            playerSearchModal,
            React.createElement(DraftPlayerStatLineStyle, null,
                React.createElement(DraftPlayerStatLine, { player: this.state.selectedPlayer })),
            React.createElement(DraftColumnStyle, null,
                React.createElement(DraftColumn, { playerPosition: 'C', title: 'Center', players: this.state.players.C, handlers: this.handlers }),
                React.createElement(DraftColumn, { playerPosition: 'LW', title: 'Left Wing', players: this.state.players.LW, handlers: this.handlers }),
                React.createElement(DraftColumn, { playerPosition: 'RW', title: 'Right Wing', players: this.state.players.RW, handlers: this.handlers }),
                React.createElement(DraftColumn, { playerPosition: 'D', title: 'Defense', players: this.state.players.D, handlers: this.handlers }),
                React.createElement(DraftColumn, { playerPosition: 'G', title: 'Goalie', players: this.state.players.G, handlers: this.handlers }))));
    }
}
;
export default DraftChoices;
const DraftChoiceStyle = styled.div `
  background-image: url(${props => props.imageURL});
  background-size: cover;
`;
const DraftPlayerStatLineStyle = styled.div `
  background-color: rgba(0,0,0,0.7);
`;
const DraftColumnStyle = styled.div `
  background-color: rgba(0,0,0,0.7);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
`;
//# sourceMappingURL=DraftChoices.js.map


// WEBPACK FOOTER //
// ./src/components/DraftChoices.js